import React from "react";
import { X, ExternalLink, Music } from "lucide-react";
import { ARTIST, ALBUM, ASSETS } from "../data/worldData";
import { PLATFORMS } from "../lib/api";

export default function TrackModal({ track, onClose }) {
  if (!track) return null;
  const links = track.links || {};
  const available = PLATFORMS.filter((p) => links[p.key] && links[p.key].trim());

  return (
    <div
      data-testid="track-modal"
      className="fixed inset-0 z-[95] flex items-center justify-center p-4 grain"
      style={{ background: "rgba(21,16,14,0.82)" }}
      onClick={onClose}
    >
      <div className="relative w-full max-w-lg bg-[#ECE7DB] text-[#15100E] edge animate-fade-up" onClick={(e) => e.stopPropagation()}>
        <div className="relative h-44 overflow-hidden border-b-2 border-[#15100E]">
          <img src={ASSETS.album} alt="" className="w-full h-full object-cover film" />
          <span className="absolute top-2 left-4 font-display font-extrabold text-[7rem] leading-none text-[#ECE7DB] mix-blend-difference">
            {String(track.n).padStart(2, "0")}
          </span>
          <button data-testid="track-modal-close" onClick={onClose} className="absolute top-3 right-3 h-9 w-9 bg-[#15100E] text-[#ECE7DB] flex items-center justify-center hover:bg-[#4E0E18] transition-colors">
            <X size={18} />
          </button>
        </div>
        <div className="p-6">
          <h3 className="font-display font-extrabold stretch-text text-4xl sm:text-5xl leading-[0.9]">{track.title}</h3>
          {track.feat && <p className="font-tech text-[#7A1623] text-sm mt-2">FEAT. {track.feat}</p>}
          <p className="font-tech text-[#15100E]/50 text-xs tracking-widest mt-2">{ARTIST} · {ALBUM}</p>

          <div className="mt-5">
            {available.length > 0 ? (
              <>
                <p className="font-tech text-[#15100E]/60 text-[11px] tracking-[0.25em] mb-3">LISTEN ON</p>
                <div className="grid grid-cols-2 gap-2">
                  {available.map((p) => (
                    <a
                      key={p.key}
                      data-testid={`track-link-${p.key}`}
                      href={links[p.key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between gap-2 border-2 border-[#15100E] px-3 py-2.5 font-tech text-[11px] tracking-[0.15em] hover:bg-[#CF9026] transition-colors"
                    >
                      <span className="flex items-center gap-2"><Music size={13} /> {p.label.toUpperCase()}</span>
                      <ExternalLink size={13} className="opacity-60" />
                    </a>
                  ))}
                </div>
              </>
            ) : (
              <div className="border-2 border-dashed border-[#15100E]/40 p-5 flex items-center gap-4">
                <div className="h-11 w-11 bg-[#15100E] text-[#ECE7DB] flex items-center justify-center shrink-0">
                  <Music size={18} />
                </div>
                <div className="flex-1">
                  <p className="font-display font-bold text-sm">STREAMING LINKS COMING SOON</p>
                  <p className="font-tech text-[#15100E]/50 text-[11px] mt-0.5">This track drops on all platforms soon.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
